import './classes/Header.css';
import { configData } from "../config";
import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
const Header = () => {

    const [user, setUser] = useState(null);
    const app_url = configData.APP_URL;
    const [toggleMenu, setToggleMenu] = useState(false);

    // const checkLoginStatus = async () => {
    //     const user = localStorage.getItem("user");
    //     if (!user) return null;

    //     try {
    //         const response = await fetch(app_url + "site/status", {
    //             headers: { "Authorization": `Bearer ${user}` },
    //         });

    //         if (response.ok) return await response.json(); // returns user object
    //         localStorage.removeItem("user");
    //         return null;
    //     } catch (error) {
    //         console.error("Error checking login status:", error);
    //         return null;
    //     }
    // };
    const checkLoginStatus = async () => {
        try {
            const response = await fetch(app_url + "site/userdetail", {
                credentials: "include", // IMPORTANT
            });

            if (response.ok) return await response.json();
            return null;
        } catch (error) {
            console.error("Error checking login status:", error);
            return null;
        }
    };

    // Logout function
    // const handleLogout = async () => {
    //     const user = localStorage.getItem("user");

    //     try {
    //         await fetch(app_url + "site/logout", {
    //             method: "POST",
    //             headers: {
    //                 "Authorization": `Bearer ${user}`,
    //                 "Content-Type": "application/json",
    //             },
    //         });
    //     } catch (error) {
    //         console.error("Logout error:", error);
    //     }

    //     localStorage.removeItem("user");
    //     setUser(null);
    //     // window.location.href = "/login";
    // };
    const handleLogout = async () => {
        try {
            await fetch(app_url + "site/logout", {
                method: "POST",
                credentials: "include",
            });
        } catch (error) {
            console.error("Logout error:", error);
        }
        setUser(null);
        localStorage.removeItem("user");
        window.location.href="/user";
    };

    useEffect(() => {
        const verifyLogin = async () => {
            const data = await checkLoginStatus();
            if (data?.user) {
                setUser(data.user);
                localStorage.setItem("user", JSON.stringify(data.user));
            } 
        };
        verifyLogin();
    }, []);
const handleMenu = () => {
    setToggleMenu(prev => !prev);
};

    return (

        <header className="header">     
            <div className="flex">
                <img
                src="/images/icon.png"
                alt="Logo"
                className=""
                />
                <span className="app-name">
                Retail POS
                </span>
            </div>
            <div>
                <ul>
                    {user ? (
                        <>
                        <li>Welcome, {user.username}</li>
                        <li><a onClick={handleLogout}>Logout</a></li>
                        <a href="#" onClick={handleMenu}>
                        <FontAwesomeIcon icon={faEllipsisV} />
                        </a>
                        {toggleMenu &&
                        <nav id="mainMenu" className="mainMenu act">
                            <div>
                                <button onClick={() => setToggleMenu(false)}>X</button>
                            </div>
                            <ul>
                                {user.role === 1 &&
                                <li><a href="/purchase-order">Purchase Order</a></li>}
                                <li><a href="/payorder">Pay Order</a></li>
                                {user.role === 1 &&
                                    <>
                                        <li><a href="/manage-items">Manage Items</a></li>
                                        <li><a href="/manage-customers">Manage Customers</a></li>
                                        <li><a href="/manage-users">Manage Users</a></li>
                                        <li><a href="/sales-report">Sales Report</a></li>
                                    </>
                                }
                            </ul>
                        </nav>}
                        </>
                    ) : (
                        <li><a href="/user">Login</a></li>
                    )}
                </ul>
            </div>
        </header>
    );
    };

export default Header;